<template>

	<div class="content background1" style="display: flex">
		<!-- 左 -->
		<div class="tableBox9" ref="menuResize" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table newTable">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<!-- <el-tab-pane label="设备类型" name="first">
							<template v-if="treeShow">
								<tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes" ref="treeDisplay"></tree>
							</template>
						</el-tab-pane> -->
						<el-tab-pane :label="$t('label_161')" name="second" width="100%">
							<!-- <template v-if="treeShow"> -->
              <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
<!--              <tree :dataTree="treeData2" :treeType="1" :pink="1" @getDeviceMes="getDeviceMes"-->
<!--                    ref="treeDisplay2"></tree>-->
							<!-- </template> -->
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
			<!-- <div class="dragBox" ref="dragResize"></div> -->
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<!-- <img style="width:100%;height:100%;" src="../../../static/img/buttonRight.png"> -->
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<!-- 右 -->
		<div class="tableBox10" ref="operaResize" :style="{'padding':width=='0px'?'0':'60px 0px 0px 350px '}">
			<div class="tableMes treeMes">
				<div class="table" v-if="!eqDetail">
					<div style="width: 100%; height:50px;">
						<!-- 左上角标题 -->
						<div style="font-weight: 900;font-size: 24px;margin-top: 2px;margin-left: 10px; width: calc(100% - 210px);float: left;height: 50px;">
							<p class="title" style="padding: 10px 10px 0 0;"><span class="spot">{{'<'+(deviceDetailMes.name==undefined?$t('label_272'):deviceDetailMes.name)+">"}}</span>
								{{$t('label_513')}}</p>
						</div>
						<!-- 下拉框 -->
						<div class="myDropdown" style=" width: 200px;border: #000000;float: left;margin-top: 0.5px; height: 50px;">
							<el-dropdown style="width: 140px;height:40px; text-align: center;">
								<el-row class="block-col-2 ">
									<el-col>
										<el-select v-model="value" :multiple="takeBack" @focus="gg()">
											<el-option @click.native="selectchange(5,true)" :value="$t('label_60')">{{$t('label_60')}}</el-option>
											<el-option @click.native="selectchange(10,true)" :value="$t('label_65')">{{$t('label_65')}}</el-option>
											<el-option @click.native="selectchange(optionval,true)" :value="$t('label_55')+optionval+$t('label_649')">
												{{$t('label_55')}}
												<el-input class="selectInput" style="width: 80px;" @input="handleChange" v-model="optionval"
												 @click.native="takeBack=true" value="自定义" />{{$t('label_649')}}
											</el-option>
											<el-option @click.native="selectchange(0,false)" :value="$t('msg_31')">{{$t('msg_31')}}
											</el-option>
										</el-select>
									</el-col>
								</el-row>
							</el-dropdown>
						</div>
					</div>
					<!-- 下主div -->
					<div style="height: calc(100% - 50px);">
						<!-- el-carouse组件是自带鼠标事件，要修改则需要清除原有事件，即鼠标的移入事件@mouseenter.native="delHandleMouseEnter"。 -->
						<el-carousel v-if="show" ref="carousel" style="width: 100%;height: 100%;" :initial-index="initialIndex" :interval="time"
						 trigger="click" arrow="always" @mouseenter.native="delHandleMouseEnter">
							<el-carousel-item v-for="(items,indexs) in selectEquipmentList" :key="indexs">
								<!-- 卡片整体 -->
								<div style="width: 156px;height: 185px;margin-top: 3px;margin-left: 4px;float: left;border:1px solid #484848;"
								 v-for="(item,index) in items" :key="index">
									<!-- 卡片上方div -->
									<!-- 悬浮提示 -->
									<el-popover :disabled="getLength(item)" placement="top-start" trigger="hover" :content="(item.code==null?'':item.code)+item.name">
										<div :style='{ background : divColor(item.id) }' style="width: 100%;height: 25%;font-weight:600;color:#000000;white-space: nowrap; cursor : pointer;"
										 slot="reference" @click="detailShow(item)">
											<li style="font-size: 12px;list-style: none; margin-left: 5px;">
												{{(item.code==null?'':item.code)+"<"+(item.companyNumber==null?'':item.companyNumber)+">"}}
											</li>
											<li style="font-size: 12px;list-style: none; margin-left: 5px;overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;"
											 slot="reference">
												{{(item.code==null?'':item.code)+item.name}}
											</li>
										</div>
									</el-popover>
									<!-- 卡片下方div -->
									<div style="width: 100%;height: 75%;background:#bdce00;">
										<!-- 卡片下左div -->
										<div style="width: 20%;height: 100%;background:#2e2f34;float: left;">

											<!-- 蓝1 -->
											<!-- 2.4 -->
											<div class="bright" :style="{background:$store.getters.getColor['5'].color}">
												<div class="zhe" v-if="lightStatus(item.id,item.code,2)"></div>
											</div>
											<!-- 红1 -->
											<!-- 2.4 -->
											<div class="bright" :style="{background:$store.getters.getColor['1'].color}">
												<div class="zhe" v-if="lightStatus(item.id,item.code,4)"></div>
											</div>
											<!-- 黄1 -->
											<!-- 2.4 -->
											<div class="bright" :style="{background:$store.getters.getColor['2'].color}">
												<div class="zhe" v-if="lightStatus(item.id,item.code,3)"></div>
											</div>
											<!-- 绿1 -->
											<!-- 2.4 -->
											<div class="bright" :style="{background:$store.getters.getColor['3'].color}">
												<div class="zhe" v-if="lightStatus(item.id,item.code,1)"></div>
											</div>


										</div>
										<!-- 下右div -->
										<div style="height: 100%;width: 80%;background: #f7f7f7;float: left;font-size: 12px;">
											<span style="">
												<!-- 运转时间 -->
												<li style="list-style: none;">
													<img src="../../assets/img/signal/clock01.png" style="width: 12px;margin-left: 8px; margin-right: 5px;">{{$t('label_28')}}
													<br>
												</li>
												<li style="list-style: none;float: left;margin-left: 40px;font-size: 16px;font-weight:600;color:#3acc10;">
													{{parseFloat(selectEfficencyList[item.id].runTime/60).toFixed(0)}}
												</li>
												<li style="list-style: none;margin-left: 96px;margin-top: 5px;">
													{{$t('label_647')}}
												</li>

												<!-- 稼动率 -->
												<li style="list-style: none;display: flex;justify-content: left;width: 100%;">
													<img src="../../assets/img/signal/clock01.png" style="width: 12px;height: 12px;margin: 2px 5px 0 8px;">
													{{$t('label_191')}}<br>
												</li>
												<li style="list-style: none;float: left;margin-left: 40px;font-size: 16px;font-weight:600;color:#3acc10;">
													<!-- 小数点后两位（四舍五入） -->
													{{ selectEfficencyList[item.id].efficency==null?'':towNumber(selectEfficencyList[item.id].efficency)>100?100:towNumber(selectEfficencyList[item.id].efficency) }}
													<!-- 没有改变 -->
													<!-- {{(selectEfficencyList[item.id].efficency==null?'':selectEfficencyList[item.id].efficency)}} -->
												</li>
												<li style="list-style: none;margin-left: 96px;margin-top: 5px;">
													%
												</li>

												<!-- 异常停止时间 -->
												<li style="list-style: none;display: flex;justify-content: left;width: 100%;">
													<img src="../../assets/img/signal/clock01.png" style="width: 12px;height: 12px;margin: 2px 5px 0 8px;">
													{{$t('label_31')}}<br>
												</li>
												<li style="list-style: none;float: left;margin-left: 40px;font-size: 17px;font-weight:600;color:#3acc10;">
													{{parseFloat(selectEfficencyList[item.id].abnormalStopTime/60).toFixed(0)}}
												</li>
												<li style="list-style: none;margin-left: 96px;margin-top: 5px;">
													{{$t('label_647')}}
												</li>
											</span>

										</div>

									</div>
								</div>
							</el-carousel-item>
						</el-carousel>

					</div>
				</div>
				<div class="table" v-else>
					<eqDetail :eqId="eqId" @detailClose="detailClose"></eqDetail>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import tree from "@/components/list/tree/equTree.vue";
  // import tree from "@/components/list/tree/tree";
	import file from "@/assets/js/file/file.js";
	import checkItem from "@/components/list/displayPage/checkItemParam";
	import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
	import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
	import electronDocument from "@/components/list/displayPage/electronDocumentParam";
	import partInfo from "@/components/list/displayPage/partInfoParam";
	import common from "@/assets/js/common/common.js";
	import organizationTabJs from "@/assets/js/system/organizationTab.js";
	import signal from "@/assets/js/signal/signal.js";
	import eqDetail from "@/components/list/equipmentDetails/eqDetail";
	import $ from 'jquery'


	export default {

		components: {
			Page,
			calendar,
			tree,
			checkItem,
			maintenanceItem,
			inspectionItem,
			electronDocument,
			partInfo,
			eqDetail
		},
		data() {
			return {
				eqDetail: false,
				eqId: '',

				initialIndex: 0,
				show: true,
				timers: null,
				timer: null,
				selectSignalColorList: [],
				selectSignalList: [],
				selectEfficencyList: [],
				selectEquipmentList: [],
				carouselAuto: false,
				optionval: '',
				visible: false,
				takeBack: false,
				value: this.$t('msg_31'),
				size: 40,
				time: 0,
				filterText: '',
				treeShow: true,
				MenuRoleList: [],
				newType: {
					name: '',
					operationState: '1',
					failureState: '1',
					lifeState: '1',
				},
				deviceDetailMes: {},
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				checked: false,
				cardData: [],
				activeNameTree: 'second',
				mainEditTree: 'project',
				activeNameDevice: 'device',
				searchDataList: {},
				equipmentStatusList: {

				},
				mainConfrimTree: 'main',
				formModel: {
					organizationId: '',
					roleName: "",
					duty: '',
					menuIds: [],
					menuNames: [],
					memberNames: [],
					memberIds: [],
					roleId: '',
				},
				deptIdList: ['0'],
				// equipmentList: [],
				//300392_status_light0运转准备(蓝) 300392_status_light1 黄灯 300392_status_light2 红灯 300392_status_light3 绿灯
				// color: [['','#4f3232','#524c35','#2f462d','','#264856'],['','#ff2f00','#cfae2b','#34ce01','','#2bd5ff'],['','#ff2f00','#cfae2b','#34ce01','','#2bd5ff']],
				// lightIndex: ['','_status_light2','_status_light1','_status_light3','','_status_light0'],
				lightIndex: ['', '_status_light3', '_status_light0', '_status_light1', '_status_light2'],
				lightFlag: true,
				width: '340px',
				qrCodeShow: false,
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},

		methods: {
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
					//this.$refs.menuResize.style.width = "0px";
					//this.$refs.operaResize.style.width = document.documentElement.clientWidth +"px";
				} else {
					this.width = "340px";
					//this.$refs.menuResize.style.width = "340px";
					//this.$refs.operaResize.style.width = document.documentElement.clientWidth -340 +"px";
				}
			},
			//显示设备详细
			detailShow: function(eq) {
				this.eqId = eq.id;
				this.eqDetail = true;
				this.initialIndex = this.$refs.carousel.activeIndex;
			},
			dropSize() {
				let that = this,
					menuWidth = 200,
					operaHeight = 200;
				this.$refs.dragResize.onmousedown = function() {
					document.onmousemove = function(e) {
						let clientX = e.clientX;
						// 最大宽度
						if (clientX >= 800) {
							clientX = 800;
						}
						// 最小宽度
						if (clientX <= 495) {
							clientX = 495;
							menuWidth = clientX - 30;
						}
						that.$refs.menuResize.style.width = clientX - 275 + "px";
						that.$refs.operaResize.style.width = window.screen.width - clientX + 35 + "px";
						document.onmouseup = function() {
							document.onmousemove = null;
							document.onmouseup = null;
							that.releaseCapture && that.releaseCapture()
						}
					}
				}
			},
			//关闭设备详细
			detailClose: function() {
				this.eqDetail = false;
			},
			getLength: function(data) {
				let str = (data.code == null ? '' : data.code) + data.name;
				let len = 0;
				for (let i = 0; i < str.length; i++) {
					if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
						len += 2;
					} else {
						len++;
					}
				}
				return len < 22;
			},
			// divLeftColor(val){
			//   if(this.selectSignalList[val].state==null){
			//   	return '#888888';
			//   }else{
			//   	for(let i=0;this.selectSignalColorList.length;i++){
			//   		if(this.selectSignalList[val].state.total==this.selectSignalColorList[i].status){
			//   			return this.selectSignalColorList[i].color;
			//   		}
			//   	}
			//   }
			// },
			// divLeftColor(val){
			//   if(this.selectSignalList[val].state==null){

			//   }
			// },
			lightStatus(id, code, status) {
				if (this.selectSignalList[id].state == null) {
					return true;
				} else {
					if (this.selectSignalList[id].data[code + this.lightIndex[status]] == undefined) {
						return true;
					}
					let st = this.selectSignalList[id].data[code + this.lightIndex[status]].value;
					if (st == 0) { //灭
						return true;
					} else if (st == 1) { //亮
						return false;
					} else if (st == 2) { //闪
						return this.lightFlag;
					} else {
						return true;
					}
				}
			},
			// divstatus(id, code, status) {
			// 	if (this.selectSignalList[id].state == null) {
			// 		return this.color[0][status];
			// 	} else {
			// 		if (this.selectSignalList[id].data[code + this.lightIndex[status]] != undefined) {
			// 			return this.color[this.selectSignalList[id].data[code + this.lightIndex[status]].value][status];
			// 		} else {
			// 			return this.color[0][status];
			// 		}
			// 	}
			// },
			/*      divstatus(val, status) {
			        if (this.selectSignalList[val].state == null) {
			          switch (status) {
			            case 1:
			              return '#4f3232';
			            case 2:
			              return '#524c35';
			            case 3:
			              return '#2f462d';
			            case 5:
			              return '#264856';
			          }
			        } else {
			          if (this.selectSignalList[val].state.total == status) {
			            switch (status) {
			              case 1:
			                return '#ff2f00';
			              case 2:
			                return '#cfae2b';
			              case 3:
			                return '#34ce01';
			              case 5:
			                return '#2bd5ff';
			            }
			          } else {
			            switch (status) {
			              case 1:
			                return '#4f3232';
			              case 2:
			                return '#524c35';
			              case 3:
			                return '#2f462d';
			              case 5:
			                return '#264856';
			            }
			          }

			          // for(let i=0;this.selectSignalColorList.length;i++){
			          // if(this.selectSignalList[val].state.total==status){
			          //   if(this.selectSignalList[val].state.total==this.selectSignalColorList[i].status){
			          //   	return this.selectSignalColorList[i].color;
			          //   }
			          // }
			          // }
			        }
			      }, */
			divColor(val) {
			  if (this.selectSignalList[val]) {
          if (this.selectSignalList[val].state == null) {
            return '#888888';
          } else {
            for (let i = 0; this.selectSignalColorList.length; i++) {
              if (this.selectSignalList[val].state.total == this.selectSignalColorList[i].status) {
                return this.selectSignalColorList[i].color;
              }
            }
          }
        }
			},
			selectchange(time, val) {
				this.initialIndex = this.$refs.carousel.activeIndex;
				this.show = false;
				this.takeBack = false
				this.carouselAuto = val;
				this.time = time * 1000;
				this.$nextTick(function() {
					this.show = true;
				})
			},
			handleChange() {
				this.optionval = this.optionval;
				this.$forceUpdate(); //解决视图更新问题
			},
			quipmentMonitoring() {
				this.$router.push({
					path: '/static/quipmentMonitoring'
				})
			},

			// selectDeptIdList(id) {
			// 	file.selectDeptIdList(id).then((response) => {
			// 		let data = response.data;
			// 		if (data.code == "1") {
			// 			this.deptIdList = data.data
			// 		}
			// 	}).catch((response) => {
			// 		console.log(response)
			// 	})
			// },
			selectDept(id) {
				file.selectDeptName(id).then((response) => {
					let data = response.data;
					if (data.code == "1") {
						this.cardData.deptName = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//从属于
			loadTree(node, resolve) {
				if (node.level === 0) {
					let child = this.getChildren(0);
					child.then((res) => {
						resolve(res);
					});
				} else {
					let child = this.getChildren(node.data.id);
					child.then((res) => {
						if (res == "") {
							return resolve([]);
						} else {
							resolve(res);
						}
					});
				}
			},
			async getChildren(pid) {
				let childArr = [];
				await organizationTabJs.getChildren({
					pid: pid
				}).then((response) => {
					let data = response.data;
					if (data.code == "1") {
						childArr = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				return childArr;
			},
			treeCheck(data, checked, indeterminate) {
				if (checked) {
					this.formModel.organizationId = data.id;
					this.cardData.deptId = data.id;
					this.$refs.tree.setCheckedKeys([data.id], true)
					this.selectDept(data.id);
					this.$refs.selectTree1.blur()
				}

			},


			// selectCard(id) {
			// 	file.selectCard(id).then((response) => {
			// 		let data = response.data;
			// 		if (data.code == "1") {
			// 			this.cardData = data.data;
			// 			this.selectDept(data.data.deptId)
			// 			if (this.cardData.autoFlag != null && this.cardData.autoFlag != '') {
			// 				this.cardData.autoFlag = this.cardData.autoFlag.toString();
			// 			}
			// 			if (this.cardData.deptId != null && this.cardData.deptId != '') {
			// 				this.selectDeptIdList(this.cardData.deptId)
			// 				this.formModel.organizationIds = this.cardData.deptId
			// 				this.$refs.tree.setCheckedKeys([this.cardData.deptId], true)
			// 			}
			// 		}
			// 	}).catch((response) => {
			// 		console.log(response)
			// 	})
			// },

			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.getTreeMes = '0';
					this.searchDataList = {}
					this.deviceDetailMes = {}
					this.deviceDetailMes.name = this.$t('label_272')
					this.deviceDetailMes.type = 2;
					this.deviceDetailMes.id = 0;
					this.newType.equipmentTypeId = data.id;
				} else {
					this.deviceDetailMes = data;
					if (data.type == '1') {
						// this.selectCard(data.id);
						// this.getEquipmentParameter(data.id);
						this.getTreeMes = '3';
					} else if (data.type == '2') {
						this.newType.deptId = data.id;
						this.getTreeMes = '0';
						this.searchDataList = {
							areaId: data.id
						}
					} else if (data.type == '0') {
						this.newType.equipmentTypeId = data.id;
						this.getTreeMes = '0';
						this.searchDataList = {
							deviceId: data.id
						}
					}
				}
				this.initialIndex = 0;
				this.selectEquipmentById();
        console.log(this.deviceDetailMes.name==undefined?this.$t('label_272'):this.deviceDetailMes.name)
			},




			handleClickTree(tab, event) {
				/*if (tab.label == '区域') {
				  this.getTreeMes = '0';
				} else {

				}*/
				this.getTreeMes = '0';
				this.searchDataList = {}
				this.deviceDetailMes = {}
				this.deviceDetailMes.name = this.$t('label_272')
				this.search()
			},
			//信号灯颜色查询
			selectSignalColor() {
				signal.selectSignalColor().then((response) => {
					let data = response.data;
					if (data.code == "1") {
						this.selectSignalColorList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//信号灯数据
			selectSignal() {
				signal.selectSignal(this.equipmentList).then((response) => {
					let data = response.data;
					if (data.code == "1") {
						this.selectSignalList = data.data
            // console.log(this.selectSignalList);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//小数点后两位方法
			towNumber(val) {
				if (val == 0) {
					return val;
				} else {
					return val.toFixed(1)
				}
			},

			//内容数据
			selectEfficency() {
				signal.selectEfficency(this.equipmentList).then((response) => {
					let data = response.data;
					if (data.code == "1") {
						this.selectEfficencyList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},


			//标题数据
			selectEquipmentById() {
				let param = {
					id: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type,
          sortName: 'code',
          sort: 'ASC'
				}
				signal.selectEquipmentById(param).then((response) => {
					let data = response.data;
					if (data.code == "1") {
						this.equipmentList = data.data
						this.addequipmentList();
						this.selectEfficency();
						this.selectSignal();
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			addequipmentList() {
				this.selectEquipmentList = []
				let list = [];
				for (let i = 0; i < this.equipmentList.length; i++) {
					list.push(this.equipmentList[i]);
					if (i == this.equipmentList.length - 1) {
						this.selectEquipmentList.push(list);
					} else {
						if (list.length == this.size) {
							this.selectEquipmentList.push(list);
							list = []
						}
					}
				}
			},

			delHandleMouseEnter() {
				// console.log(this.$refs.carousel.handleMouseEnter)
				this.$refs.carousel.handleMouseEnter = () => {};
			},

			test(item) {
				this.size = item;
				this.addequipmentList();
			},
		},
		//更新数据接口
		beforeDestroy() {
			clearInterval(this.timer);
			this.timer = null;
			clearInterval(this.timers);
			this.timers = null;
		},
		created() {
			this.selectSignalColor();
			// this.selectEquipmentById();
			//每分钟更新卡片下面数据接口
			this.timer = setInterval(() => {
				this.selectEfficency();
			}, 60000)
			//每秒钟更新信号灯接口
			this.timers = setInterval(() => {
				this.lightFlag = !this.lightFlag;
				this.selectSignal();
			}, 1000)
			this.MenuRoleList = this.$store.getters.getMenu;
		},
		mounted() {
			window.test = this.test;

			// this.$nextTick(() => {
			// 	this.dropSize();
			// })
		}
	}
</script>

<style>
	.newTable .el-tabs--card>.el-tabs__header .el-tabs__item {
		width: 315px;
	}

	.zhe {
		width: 100%;
		height: 100%;
		background-color: #000;
		opacity: 0.7;
	}

	.myDropdown .el-select-dropdown.el-popper {
		z-index: 6666 !important;
	}

	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;

		margin: auto;
	}

	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #37b08e;
		font-size: 16px;
	}

	.el-icon-arrow-down {
		font-size: 16px;
	}

	.bright {
		height: 22.5%;
		width: 84%;
		margin-left: 8%;
		margin-top: 8%;
	}

	.div .red {
		background: #ff2f00;
	}

	.div .yellow {
		background: #cfae2b;
	}

	.div .green {
		background: #34ce01;
	}

	.div .grey {
		background: #afafaf;
	}

	.selectInput .el-input__inner {
		height: 30px;
	}

	.el-carousel__container {
		height: 100%;
	}

	.newTable .el-tab-pane {
		height: 100%;
		overflow: auto;
	}

	.el-carousel__container {
		height: 100% !important;
	}

	.el-carousel__item.is-animating {
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentOperation/signalLamp.vue